/**
 * Created by Andrey Popov on 08.12.2025
 */

const Multiple = function (unit) {
    UnitComponent.call(this, unit);

    this.init(0, 1);
    this.pathInfoViews = new PathInfoViews();

    cleverapps.eventBus.on("openInfoView", this.onOpenInfoView.bind(this), this);
    cleverapps.eventBus.on("mapEvent", (type, options) => {
        if (type === Map2d.CLICK_UNIT && (options.affected.x !== this.unit.x || options.affected.y !== this.unit.y)) {
            this.onOpenInfoView();
        }
    }, this);
};

Multiple.prototype = Object.create(UnitComponent.prototype);
Multiple.prototype.constructor = Multiple;

Multiple.prototype.init = function (indexInCell, countOfUnits, unitsVisibility) {
    this.unitsVisibility = cleverapps.arrayFill(countOfUnits, 1);
    this.indexInCell = indexInCell;

    if (unitsVisibility !== undefined) {
        for (let i = 0; i < countOfUnits; i++) {
            this.unitsVisibility[i] = (unitsVisibility >> i) & 1;
        }
    }
};

Multiple.prototype.calcShift = function () {
    const fakeUnitData = Map2d.currentMap.fogs.getFakeUnits(this.unit.x, this.unit.y)[this.indexInCell];
    return cc.p(fakeUnitData && fakeUnitData.shiftX || 0, fakeUnitData && fakeUnitData.shiftY || 0);
};

Multiple.prototype.hideUnitInCell = function (index) {
    this.unitsVisibility[index] = 0;

    if (this.view) {
        this.view.updateVisibility(true);
    }
};

Multiple.prototype.isUnitVisible = function () {
    return this.unitsVisibility[this.indexInCell];
};

Multiple.prototype.hasVisibleUnits = function (excludeSelf) {
    for (let i = 0; i < this.unitsVisibility.length; i++) {
        if (this.unitsVisibility[i] && (!excludeSelf || i !== this.indexInCell)) {
            return true;
        }
    }
};

Multiple.prototype.save = function (data) {
    if (this.unitsVisibility) {
        let packed = 0;
        for (let i = 0; i < this.unitsVisibility.length; i++) {
            if (this.unitsVisibility[i]) {
                packed |= (1 << i);
            }
        }

        data.uv = packed >>> 0;
    }
};

Multiple.prototype.joinWith = function (existingUnits) {
    if (!existingUnits || (existingUnits instanceof Unit && !existingUnits.findComponent(Multiple))) {
        return this.unit;
    }

    if (Array.isArray(existingUnits)) {
        existingUnits.push(this.unit);
        return existingUnits;
    }

    return [existingUnits, this.unit];
};

Multiple.prototype.handleRemove = function () {
    const map = Map2d.currentMap;
    const unit = this.unit;
    const mainUnit = map.getUnit(unit.x, unit.y);
    const mapUnits = map.getUnits(unit.x, unit.y);

    if (!mapUnits.find((mapUnit) => mapUnit === unit)) {
        if (cleverapps.config.debugMode) {
            console.log(unit, mainUnit);
            throw "Cant be! ";
        }
    }

    const sortedVisible = mapUnits.filter((u) => this.unitsVisibility[u.findComponent(Multiple).indexInCell])
        .sort((a, b) => {
            const sa = a.findComponent(Multiple).calcShift();
            const sb = b.findComponent(Multiple).calcShift();
            return (sa.x + sa.y) - (sb.x + sb.y);
        });
    const selfPos = sortedVisible.indexOf(unit);
    const nextActive = sortedVisible[selfPos + 1] || sortedVisible[selfPos - 1];

    mapUnits.forEach((mapUnit) => {
        mapUnit.findComponent(Multiple).hideUnitInCell(this.indexInCell);
    });

    this.updateInfoViews(nextActive);

    if (this.hasVisibleUnits()) {
        mainUnit.save();
    } else {
        const cellUnits = Map2d.currentMap.getUnits(this.unit.x, this.unit.y);
        map.remove(Map2d.LAYER_UNITS, unit.x, unit.y);
        cellUnits.forEach((cellUnit) => {
            cellUnit.destructor();
            cellUnit.removeFromMap();
        });
    }
};

Multiple.prototype.handleClick = function () {
    const unitInfoView = this.getInfoViews().getUnitInfoView(this.unit, true);
    if (unitInfoView && unitInfoView.onClicked) {
        unitInfoView.onClicked();
        return true;
    }

    if (this.hasVisibleUnits(true)) {
        this.updateInfoViews();
        return true;
    }
};

Multiple.prototype.onOpenInfoView = function () {
    this.getInfoViews().hide();
};

Multiple.prototype.updateInfoViews = function (preferredActive) {
    const mainUnit = Map2d.currentMap.getUnit(this.unit.x, this.unit.y);
    if (mainUnit !== this.unit) {
        mainUnit.findComponent(Multiple).updateInfoViews(preferredActive);
        return;
    }

    const infoViews = this.getInfoViews();
    if (!infoViews) {
        return;
    }

    const cellUnits = Map2d.currentMap.getUnits(this.unit.x, this.unit.y).filter((unit) => {
        const idx = unit.findComponent(Multiple).indexInCell;
        if (this.unitsVisibility[idx]) {
            return true;
        }
        infoViews.removeInfoViewForUnit(unit);
        return false;
    }).sort((a, b) => {
        const sa = a.findComponent(Multiple).calcShift();
        const sb = b.findComponent(Multiple).calcShift();
        return (sa.x + sa.y) - (sb.x + sb.y);
    });

    cellUnits.splice(Multiple.MAX_INFO_VIEWS).forEach((unit) => infoViews.removeInfoViewForUnit(unit));

    if (cellUnits.length > 0) {
        const activeUnit = cellUnits.includes(preferredActive) ? preferredActive : cellUnits[0];
        infoViews.updateInfoViews(activeUnit, cellUnits);
    } else {
        infoViews.hide(true);
    }
};

Multiple.prototype.getInfoViews = function () {
    const mainUnit = Map2d.currentMap.getUnit(this.unit.x, this.unit.y);
    return mainUnit.findComponent(Multiple).pathInfoViews;
};

Multiple.prototype.destructor = function () {
    runCleaners(this);
};

Multiple.MAX_INFO_VIEWS = 3;
Multiple.MAX_PER_CELL = 8;